<template>
  <div>
    <header class="loginHeader">
      <div class="headerLeft">
        <img :src="logo1" width="32" height="32" alt='' />
        <img :src="logo2" width="84" height="20" alt='' />
        <img :src="logo3" width="180" height="16" alt='' />
      </div>
      <div class="headerRight">
        <a class="centerLink" href='https://www.orangev.cn/' target='_blank'>
          了解橙子维管
        </a>
        <span class="verticalSeparator"></span>
        <a class="centerLink" href='/center' >
          登录数据中心
        </a>
      </div>
    </header>
    <main class="loginMain">
      <div class="bg">
        <el-image
          :src="bg"
          alt=''
          layout='fill'
          style="width: 100%;height: 100%;"
          fit='cover'
        />
      </div>
      <div class="sectionCards">
        <Card
          :onOpen="onOpen"
          :open="activeOOpenKey === '专注母婴'"
          name='专注母婴'
          title="<div>
            五年间
            <br />
            专注线下母婴渠道管理
            <br />
            提供高效信息化解决方案
          </div>"
          subTitle='一键触达门店及导购，告别繁琐，渠道维护如虎添翼'
          :img="iconA1" />
        <Card
          :open="activeOOpenKey === '有效激励'"
          :onOpen="onOpen"
          name='有效激励'
          title='灵活多样的渠道激励工具'
          subTitle='市场费用直达终端，有效提振渠道销售积极性'
          :img="iconA2"
        />
        <Card
          :open="activeOOpenKey === '安全风控'"
          :onOpen="onOpen"
          name='安全风控'
          title='历经市场验证的风控解决方案'
          subTitle='实时多维度风控机制，避免费用虚耗，资金安心入账'
          :img="iconA3"
        />
        <Card
          :open="activeOOpenKey === '数据管理'"
          :onOpen="onOpen"
          name='数据管理'
          title='通过数据全息掌控渠道动向'
          subTitle="
          <div>
          实时获取数据报表，掌握终端库存动销情况
          <br />
          快捷生成多维度图表分析报告
        </div>
        "
        :img="iconA4"
        />
      <Card
        :open="activeOOpenKey === '业务协作'"
        :onOpen="onOpen"
        name='业务协作'
        title='助力业务维护市场如虎添翼'
        subTitle="
                <div>
                业务员通过平台进行门店签约、规则设定、费用审核
                <br />
                实现对终端的灵活高效操盘
              </div>
              "
        :img="iconA5"
      />
      </div>
      <div style="width: 330px;flex-shrink: 0;"></div>
      <div class="login-box">
        <el-form :model="UserDTO" :rules="rules" ref="loginForm" class="login-form">
          <h6 class="title" style="margin-top: -20px">渠道数据中心</h6>
          <el-tabs style="height: 310px;text-align: center" v-model="thisTabs" @tab-click="handleClick" stretch>

            <el-tab-pane label="微信扫码登录" name="first">
              <div v-loading="loading1" style="display: inline-block;">
                <img style="cursor:pointer;border:1px solid #f2f1e8;border-radius: 10px;box-shadow: 0 0 5px #cac6c6;" width="60%" height="60%;" :src="qrCodeUrl"
                     @click="getQrCode" title="点击刷新"
                     :onerror="'javascript:this.src=\''+ errorImg + '\''"/>
              </div>
              <div style="font-size: 10px;margin: auto;text-align: center;width: 65%">
                <p style="margin: 0.5rem 0 0 0;font-size: 1rem">微信扫一扫</p>
                <p style="margin: 0">
                  如扫码异常请下载最新版微信客户端或联系平台管理员
                </p>
              </div>
            </el-tab-pane>
            <el-tab-pane label="账号密码登录" name="second">
              <el-form-item prop="username" style="margin-top: 20px;width: 85%;margin-left: 1rem">
                <el-input
                  v-model="UserDTO.username"
                  autocomplete="off"
                  placeholder="账户:"
                  prefix-icon="el-icon-goods">
                </el-input>
              </el-form-item>
              <el-form-item prop="password" style="margin-top: 30px;width: 85%;margin-left: 1rem">
                <el-input :type="textType"
                          v-model="UserDTO.password"
                          @keyup.native.enter="login('UserDTO')"
                          autocomplete="off"
                          placeholder="密 码:"
                          prefix-icon="el-icon-time"
                          show-password>
                </el-input>
              </el-form-item>
              <el-form-item v-show="showMsg" style="margin-bottom:0;">
                <span class="text-danger">提示：用户名或密码错误，请重试！</span>
              </el-form-item>
              <el-form-item>
                <el-button type="warning" @click="login()" class="login-btn" v-loading="loading2">登 录</el-button>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </div>
    </main>
    <footer class="loginFooter">
      版权所有：上海橙籽维管信息有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;沪ICP备17022529号-1
    </footer>
  </div>
</template>



<script>


import jwtDecode from 'jwt-decode'
import AES from '../api/AES'
import {querySupplierData, getQrCode, getToken, login} from '@/api/login'
import errorImg1 from "@/assets/errorImg/f127cbec-14f4-4050-8dbc-2e1beda66761.jpg"
import logo1 from "@/assets/logo1.svg"
import logo2 from "@/assets/logo2.svg"
import logo3 from "@/assets/logo3.svg"
import iconA1 from "@/assets/icon-a-1.svg"
import iconA2 from "@/assets/icon-a-2.svg"
import iconA3 from "@/assets/icon-a-3.svg"
import iconA4 from "@/assets/icon-a-4.svg"
import iconA5 from "@/assets/icon-a-5.svg"
import bg from "@/assets/backgroundImage.jpg"
import Card from "@/components/loginCard/card";


export default {
  components: {Card},
  data () {
    return {
      components:{Card},
      errorImg:errorImg1,
      logo1:logo1,
      logo2:logo2,
      logo3:logo3,
      iconA1:iconA1,
      iconA2:iconA2,
      iconA3:iconA3,
      iconA4:iconA4,
      iconA5:iconA5,
      bg:bg,
      UserDTO: {
        username: '',
        password: '',
        xm: '',
        supplierShortName:''
      },
      rules: {
        username: [
          { required: true, message: ' 账号不可以为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不可以为空 ', trigger: 'blur' }
        ]
      },
      loading1: false,
      loading2: false,
      showMsg: false,
      textType: 'password',
      thisTabs: 'first',
      qrCode: true,
      qrCodeUrl: '',
      activeOOpenKey:'专注母婴'
    }
  },
  created: function () {
    localStorage.clear()
    if (this.qrCode)
      this.getQrCode();
    window.setInterval(() => {
      if (this.qrCode) {
        setTimeout(this.getUserToken(), 0)
      }
    }, 3000);
  },
  methods: {
    onOpen(name){
      this.activeOOpenKey = name
    },
    getQrCode() {
      this.loading1 = true;
      getQrCode(Math.floor(Math.random() * 100000 * 100000)).then((res) => {
        if (res.data != null) {
          this.qrCodeUrl = res.data
          this.qrCode = true;
          this.loading1 = false
        }
      })
    },
    handleClick(tab, event) {
      if (tab.name == 'first') {
        this.getQrCode();
      } else {
        this.qrCode = false;
      }
    },
    login () {
      this.loading2 = true;
      login(this.UserDTO).then(res => {
        let {data} = res;
        if (data.code === 200) {
          this.$notify({
            type: 'success',
            message: data.msg,
            title: '成功',
            position: 'bottom-right'
          })
          // 解析token
          const decode = jwtDecode(data.date.token)
          // token下的姓名进行转义
          const Data = decodeURIComponent(decode.xm)
          // 判断是否登录成功
          this.UserDTO.xm = Data
          sessionStorage.setItem('user', JSON.stringify(this.UserDTO))
          // 把权限持久性存储 权限和供应商id和token
          localStorage.setItem('qx', AES.encrypt(decode.qx,null))
          localStorage.setItem('token', data.date.token)
          localStorage.setItem('supplierId', decode.sub)
          localStorage.setItem('bonus_order', decode.order)
          localStorage.setItem('stock', decode.stock)
          localStorage.setItem('dashboardSales', decode.dashboardSales)
          localStorage.setItem('managerId', null);
          localStorage.setItem('isAdmin', decode.isAdmin);
          localStorage.setItem('resourceBundle', decode.resourceBundle);
          this.getPackageCount(res.data.date.token,decode.sub)
        }else{
          if (data.code == 500){
            this.$notify.error({
              title: '错误',
              message: data.msg != "Bad credentials" ? data.msg : '提示：用户名或密码错误，请重试！',
              position: 'bottom-right'
            })
          }
          this.loading2 = false;
        }
      }).catch(error => {
        if (error.response){
          let status = error.response.status
          this.loading2 = false;
          if (status == 500){
            this.$notify.error({
              title: '错误',
              message: '提示：用户名或密码错误，请重试！',
              position: 'bottom-right'
            })
          }
        }
      })
    },
    getUserToken() {
      getToken().then((res) => {
          if (res.data.code != 200 && res.data.date == null) {
            this.loading = true;
            this.qrCode = false;
            this.$notify({
              type: 'error',
              message: res.data.msg,
              title: '登录失败',
              position: 'bottom-right'
            })
            this.loading1 = false;
            this.getQrCode();
          } else if (res.data.date.token != null && res.data.date.token != '') {
            this.$notify({
              type: 'success',
              message: '登录成功',
              title: '成功',
              position: 'bottom-right'
            })
            this.qrCode = false;
            const decode = jwtDecode(res.data.date.token)
            const xm = decodeURIComponent(decode.xm);
            const supplierShortName = decodeURIComponent(decode.supplierShortName);
            // 判断是否登录成功
            this.UserDTO.xm = xm
            this.UserDTO.supplierShortName = supplierShortName
            sessionStorage.setItem('user', JSON.stringify(this.UserDTO))
            // 把权限持久性存储 权限和供应商id和token
            localStorage.setItem('qx', AES.encrypt(decode.qx, null))
            localStorage.setItem('token', res.data.date.token)
            localStorage.setItem('supplierId', decode.sub)
            localStorage.setItem('bonus_order', decode.order)
            localStorage.setItem('stock', decode.stock)
            localStorage.setItem('dashboardSales', decode.dashboardSales)
            localStorage.setItem('managerId', decode.managerId);
            localStorage.setItem('isAdmin', decode.isAdmin);
            localStorage.setItem('userSupplierId', decode.userSupplierId);
            this.getPackageCount(res.data.date.token,decode.sub)
          }
        }
      )
    },
    getPackageCount(token,supplierId) {
      const from = sessionStorage.getItem('from');
      querySupplierData(token,supplierId).then(({data}) => {
        const {packageCount} = data.data
        if (packageCount === 0) {
          this.$router.push({name: 'DataUpload'})
        } else if (from === 'v') {
          this.$router.push({name: 'ReportDetailPagePurchase'})
        } else {
          this.$router.push({name: 'console'})
        }
      }).finally(() => {
        this.loading2 = false
        this.loading1 = false
        sessionStorage.removeItem('from')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.loginHeader{
  height: 50px;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  background: linear-gradient(180deg, #f5efe8 0%, #ffffff 100%);
  font-family: 'PingFang SC';
  z-index: 20000;


  .headerLeft{
    display: flex;
    align-items: center;
    padding-left: 20px;
  }

  .headerLeft > *:not(:last-child) {
    margin-right: 20px !important;
  }

  .headerRight{
    display: flex;
    align-items: center;

    .verticalSeparator{
      display: inline-block;
      width: 1px;
      height: 12px;
      background-color: #666;
    }

    .centerLink:hover,
    .headerLink:hover {
      color: #FEA500;
    }

    .centerLink{
      padding: 0 20px;
      height: 100%;
      font-size: 14px;
      color: #666;
      display: flex;
      align-items: center;
      transition: all .2s linear;
      position: relative;
      overflow: hidden;
      -webkit-transform: perspective(1px) translateZ(0);
      transform: perspective(1px) translateZ(0);
    }
    .centerLink:before {
      content: "";
      position: absolute;
      z-index: -1;
      left: 51%;
      right: 51%;
      bottom: 0;
      background: #FEA500;
      height: 4px;
      -webkit-transition-property: left, right;
      transition-property: left, right;
      -webkit-transition-duration: 0.3s;
      transition-duration: 0.3s;
      -webkit-transition-timing-function: ease-out;
      transition-timing-function: ease-out;
    }
    .centerLink:hover:before, .centerLink:focus:before, .centerLink:active:before {
      left: 0;
      right: 0;
    }
  }
}

.loginMain,.sectionCards{
  --card-expand-width: calc(max(100vw, var(--page-min-width)) / 3);
  --card-collapse-width: 80px;
  --card-height: calc(var(--card-expand-width, calc(100vw / 3)) * 0.7);
  min-height: calc(var(--card-height) + 2 * 40px);
  height: calc(100vh - 2 * 50px);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .bg{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
  }
}
.sectionCards > *:not(:last-child) {
  margin-right: 40px !important;
}
.loginMain > *:not(:last-child):not(:first-child) {
  margin-right: 40px !important;
}

.loginFooter{
  position: fixed;
  bottom: 0;
  background: #414042;
  color: white;
  text-align: center;
  width: 100%;
  height: 50px;
  line-height: 50px;
}

.login-box {
  box-sizing: border-box;
  overflow: hidden;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  position: absolute;
  top: calc(50% - 175px);;
  right: 5%;
  z-index: 0;

  .login-form {
    border-radius: 5px;
    background-clip: padding-box;
    margin:auto;
    width: 240px;
    height: 300px;
    padding: 35px 20px 15px 20px;
    background: white;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 5px #cac6c6;
    opacity: 0.8;

    .title {
      margin: 1rem auto;
      text-align: center;
      font-size: 1.25rem;
      line-height: 1.6;
      font-family: 'Avenir', Helvetica, Arial, sans-serif;
      color: black;
      font-weight: unset;
    }
    .text-danger {
      color: #F56C6C;
    }

    .login-btn {
      width: 80%;
      margin-top: 1rem;
      background: #ef6c00;
    }

    .login-btn:hover,.login-btn:hover {
      width: 80%;
      margin-top: 1rem;
      background: #f19837;
    }
  }
}


</style>
